<template>
  <div class="animated fadeIn">
    <div v-if="$route.name == 'Menu'" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> Menus
            <router-link
              class="pull-right btn btn-success btn-sm"
              :to="{ name: 'MenuNew', params: { isNew: true } }"
            >
              New
            </router-link>
          </div>
          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by Menu name"
            >
          </div>

          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
            <div class="table-responsive">
              <table
                v-if="total"
                class="entities table table-bordered table-striped table-sm"
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in entities" :key="item.id" :data-id="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td class="table-list__cell--narrow">
                      <router-link
                        class="btn btn-primary btn-sm"
                        :to="{ name: 'MenuEdit', params: { id: item.id }}"
                      >
                        Edit
                      </router-link>
                      <button
                        v-if="item.name !== mainMenu"
                        class="btn btn-danger btn-sm"
                        @click="deleteEntity(item.id)"
                      >
                        Delete <span class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Pager from '@/global/components/Pager';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'Menus',

  components: {
    pager: Pager,
  },

  mixins: [ListPageMixin, CommonPageMixin],

  data() {
    return {
      mainMenu: '',
    };
  },

  watch: {
    '$route.name': function (newVal) {
      if (newVal === 'Menu') {
        this.getSource();
      }
    },
  },

  mounted() {
    this.mainMenu = this.$config.mainMenu;
  },

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}menu?search_string=${escape(this.searchQuery)}&page=${page}`)
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.spinner) { this.$refs.spinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;
            const entities = response.data;
            delete entities.meta;
            this.entities = Object.keys(entities).map(e => entities[e]);
          }
        })
        .catch((error) => { this.$_errorCallback(error); });
    },
    deleteEntity(entityId) {
      if (window.confirm('Do you really want to delete this menu?')) {
        const $btnDeleteLoader = $(`table.entities tr[data-id="${entityId}"] .btn-danger .btn-loader`);
        $btnDeleteLoader.show();
        this.$apiHttp.delete(`${this.$config.app_api.prefix}menu/${entityId}`)
          .then(() => {
            $btnDeleteLoader.hide();
            this.getSource();
            this.$store.commit('notifications/setSuccessNotification', 'Deleted.');
          })
          .catch((error) => {
            $btnDeleteLoader.hide();
            this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in deleting menu request' });
            console.error('Error in deleteMenu mutation, ', error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?506d2d2a